// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2vOGr","header":"PatientQuestionnaire_header__286sR","info":"PatientQuestionnaire_info__1XMQl"};